import React from "react";
import "../../styles.scss";
import srivenlogo from '../../assets/globalImgs/Sriven logo.png'

function AppFooter() {
  const currentYear = new Date().getFullYear();
  return (
    <footer class="app-footer">
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-lg-4 col-md-4">
                <span>
                <a href="https://myworkwise360.com/" target="_blank" rel="noopener noreferrer">WorkWise 360</a> &copy; {currentYear}.
                </span>
            </div>
            <div class="col-lg-4 col-md-4 text-center">
                <ul class="list-inline mb-0">
                    <li class="list-inline-ite"><a href={'/TermsAndCondition'}>Terms and Conditions</a></li>
                </ul>
            </div>
            <div class="col-lg-4 col-md-4 text-right">
                <span class="powered-by">Powered By - <img src={srivenlogo} alt="Sriven Solutions"/></span>
            </div>
        </div>
    </div>
</footer>

  );
}

export default AppFooter;
